import { render, staticRenderFns } from "./matchAddCompany.vue?vue&type=template&id=02c64dde&scoped=true&"
import script from "./matchAddCompany.vue?vue&type=script&lang=js&"
export * from "./matchAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./matchAddCompany.vue?vue&type=style&index=0&id=02c64dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c64dde",
  null
  
)

export default component.exports